import React from 'react'
import { I18n } from '@front/volcanion'

import { Box, Typography, Grid } from '@mui/material'

import { DriverLink, LicenseLink, VehicleLink } from '@abra/elements'

const Column1 = ({ driver_id }) =>
  <Grid
    container
    sx={{ borderLeft: 2, borderColorLeft: 'primary.main', borderRight: 2, borderColorRight: 'primary.main' }}
    size="grow">
    <Grid size={12}>
      <Typography color={'primary'} variant={'h6'}> {I18n.t('driver.label', { count: 1 })} </Typography>
    </Grid>
    <Grid size={12}>
      <DriverLink title={I18n.t('driver.code')} record_id={driver_id} />
    </Grid>
  </Grid>

const Column2 = ({ license_id, vehicle_id }) =>
  <Grid
    container
    sx={{ borderRight: 2, borderColorRight: 'primary.main' }}
    size="grow">
    <Grid size={12}>
      <Typography color={'primary'} variant={'h6'}> {I18n.t('driver.pairing')} </Typography>
    </Grid>
    <Grid size={12}>
      <LicenseLink title={I18n.t('contract.id')} record_id={license_id} />
    </Grid>
    <Grid size={12}>
      <VehicleLink title={I18n.t('vehicle.label', { count: 1 })} record_id={vehicle_id} />
    </Grid>
  </Grid>

const Column3 = ({ vehicle_driver_id, license_driver_id }) =>
  <Grid
    container
    sx={{ borderRight: 2, borderColorRight: 'primary.main' }}
    size="grow">
    <Grid size={12}>
      <Typography color={'primary'} variant={'h6'}>  {I18n.t('driver.already_paired')} </Typography>
    </Grid>
    <Grid size={12}>
      <DriverLink title={I18n.t('contract.already_taken')} record_id={license_driver_id} />
    </Grid>
    <Grid size={12}>
      <DriverLink title={I18n.t('vehicle.already_taken')} record_id={vehicle_driver_id} />
    </Grid>
  </Grid>

const PairingDetails = ({ driver_id, license_id, vehicle_id, vehicle_driver_id, license_driver_id }) =>
  <Box sx={{ p: 2, boxShadow: 6, borderRadius: 1 }}>
    <Grid container spacing={1}>
      <Column1 driver_id={driver_id} />
      <Column2 license_id={license_id} vehicle_id={vehicle_id} />
      <Column3 vehicle_driver_id={vehicle_driver_id} license_driver_id={license_driver_id} />
    </Grid>
  </Box>

export default React.memo(PairingDetails)
